module.exports = {
	UpdateSummonDataEvent : "UpdateSummonDataEvent",
	UpdateSummonShareDataEvent : "UpdateSummonShareDataEvent",
	UpdateSummonSingleDataEvent : 'UpdateSummonSingleDataEvent',
	PartnerSummonSuccess: "PartnerSummonSuccess", 
	PartnerSummonFiveStar: "PartnerSummonFiveStar", 
}